import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import resourcesRU from './locales/ru/resources';


// the translations
const resources = {
    ru: {
        translation: resourcesRU
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "ru",
        fallbackLng: "ru",

        keySeparator: ".",

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;